module.exports = __webpack_public_path__ + "img/Key Indicators.a33013dc.png";